import TableRow from '@tiptap/extension-table-row';

export default TableRow.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                parseHTML: (element) => element.style?.cssText,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
